import { render, staticRenderFns } from "./EquipPointDetailTable.vue?vue&type=template&id=6ecc08c0"
import script from "./EquipPointDetailTable.vue?vue&type=script&lang=js"
export * from "./EquipPointDetailTable.vue?vue&type=script&lang=js"
import style0 from "./EquipPointDetailTable.vue?vue&type=style&index=0&id=6ecc08c0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports